export const isSignedPhase = (state) =>
  Boolean(state.docusealFormSubmitted || state.docusealFormCompleted)
